import { getMacrogruppi } from "./macrogroups";
import { byRanking } from './utils/byRanking';
import { getConfiguration } from "./utils/configuration";

export function parseMacroGruppi(aggregateMap, sportId, isLive) {
    const conf = getConfiguration();
    let macrogruppi = [];
    
    try {
        const macrogruppiSport = getMacrogruppi(sportId);
        if (macrogruppiSport !== undefined) {
            macrogruppi = isLive ? macrogruppiSport.live : macrogruppiSport.prematch;
            const aggsRankingMap = new Map();
            let ranking = 1;
            if (macrogruppi.length > 0) {
                let betGroupAll = false;
                // Aggiungi le aggregate ai macrogruppi
                macrogruppi = macrogruppi.filter(mg => {
                    // Always return the macro group "all"
                    if (mg.id < 0) {
                        betGroupAll = mg;
                        return true;
                    }
                    // Add all the bet groups that are inside the bet group map (if any)
                    const aggregate = [];
                    mg.aggregate.forEach(function(ag) {
                        if (typeof aggregateMap[ag] !== 'undefined') {
                            const aggData = aggregateMap[ag];
                            aggregate.push(aggData);
                            if (!aggsRankingMap.has(ag)) {
                                aggsRankingMap.set(ag, ranking);
                                ranking++;
                            }
                        }
                    });
                    if (conf.agrm === false) {
                        aggregate.sort(byRanking);
                    }
                    mg.aggregate = aggregate;
                    // Return the current macrogroup if it includes one or more bet groups
                    return aggregate.length > 0;
                });
                // Populate the macro group "all" if it doesn't include any bet groups
                if (betGroupAll != null && betGroupAll.aggregate.length === 0) {
                    const aggs = Array.from(Object.values(aggregateMap));

                    if (conf.agrm === false) {
                        aggs.sort(byRanking);
                    } else {
                        aggs.sort((a, b) => {
                            const aId = a.idAggregata;
                            const bId = b.idAggregata;

                            // Al least one is negative
                            if (aId < 0 || bId < 0) {
                                if (aId < 0 && bId < 0) return 0;   // Both negative => order unchanged
                                return aId < 0 ? -1 : 1;    // One negative => negative first
                            }
                            
                            const ra = aggsRankingMap.get(aId);
                            const rb = aggsRankingMap.get(bId);
                        
                            if (ra === undefined && rb === undefined) return 0;   // Both unranked => order unchanged
                            if (ra === undefined) return 1;   // a unranked => b first
                            if (rb === undefined) return -1;  // b unranked = a first
                        
                            return ra - rb;   // Both ranked => sort by ranking
                        });
                    }
                    betGroupAll.aggregate = aggs;
                }
            }
        }
    } catch (e) {
        if (aggregateMap != null) {
            console.error(e);
        }
    }
    
    return macrogruppi;
}
